import axios from 'axios';
import * as combinedScheduleActions from '../combined-schedules/actions';
import { roundTimeDown } from '../../../utils/time';
import moment from 'moment';

export const fetchCombinedSchedulesWithSeatAllocations =
  ({ group_id, start_time, end_time, mode }) =>
  dispatch => {
    const startTime = roundTimeDown(moment(start_time) || moment());
    const endTime = roundTimeDown(moment(end_time) || moment());
    const params = {
      start_time: startTime.format(),
      end_time: endTime.format(),
      mode
    };
    const url = `/api/v2/groups/${group_id}/auto_allocate_duty_functions`;
    return axios
      .get(url, { params })
      .then(response => {
        const schedules = response.data;
        // handle the schedules in *merge* mode
        dispatch(combinedScheduleActions.batchCombinedScheduleUpdated(schedules));
      })
      .catch(error => {
        const { statusText, status } = error.response;
        dispatch(combinedScheduleActions.fetchFailed({ statusText, status }));
      });
  };
